import React from "react";

const PasswordStrengthMeter = ({ password }) => {
  const getStrength = (pwd = "") => {
    let strength = 0;
    if (pwd.length >= 8) strength += 1;
    if (/[A-Z]/.test(pwd)) strength += 1;
    if (/[a-z]/.test(pwd)) strength += 1;
    if (/[0-9]/.test(pwd)) strength += 1;
    if (/[^A-Za-z0-9]/.test(pwd)) strength += 1;
    return strength;
  };

  const strength = getStrength(password || "");

  const getStrengthLabel = () => {
    switch (strength) {
      case 0:
        return "";
      case 1:
        return "Very Weak";
      case 2:
        return "Weak";
      case 3:
        return "Moderate";
      case 4:
        return "Strong";
      case 5:
        return "Very Strong";
      default:
        return "";
    }
  };

  const getStrengthColor = () => {
    switch (strength) {
      case 1:
        return "red";
      case 2:
        return "orange";
      case 3:
        return "yellow";
      case 4:
        return "lightgreen";
      case 5:
        return "green";
      default:
        return "transparent";
    }
  };

  // Hide until user types something
  if (!password) return null;

  return (
    <div style={{ marginTop: "8px" }}>
      <div
        style={{
          height: "8px",
          width: "100%",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${(strength / 5) * 100}%`,
            backgroundColor: getStrengthColor(),
            transition: "width 0.3s ease-in-out",
          }}
        />
      </div>
      <p
        style={{
          marginTop: "4px",
          fontSize: "14px",
          fontWeight: "bold",
          color: getStrengthColor(),
        }}
      >
        {getStrengthLabel()}
      </p>
    </div>
  );
};

export default PasswordStrengthMeter;
